<template>
  <div class="home-page">
    <section class="banner">
      <div class="banner-container">
        <div class="banner-slide" v-for="(img, idx) in bannerImages" :key="idx"
          :class="{ active: currentBannerIndex === idx }">
          <img :src="img" alt="医院banner" />
        </div>
        <div class="banner-dots">
          <span class="banner-dot" v-for="(img, idx) in bannerImages" :key="idx"
            :class="{ active: currentBannerIndex === idx }" @click.prevent="currentBannerIndex = idx"></span>
        </div>
      </div>
    </section>
    <section class="announcement-section">
      <div class="container">
        <div class="announcement-card">
          <div class="announcement-tag">
            <span class="announcement-icon">📢</span>
            <span class="announcement-label">公告公示</span>
          </div>
          <div class="announcement-scroll-container" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
            <div class="announcement-scroll-wrapper" :style="{ transform: `translateY(-${currentNoticeIndex * 40}px)` }">
              <template v-for="(item, idx) in displayNotices">
                <a v-if="item.external_link" :key="'notice-a-'+idx" :href="item.external_link" target="_blank" class="announcement-item">
                  <span class="announcement-bullet">•</span>
                  <span class="announcement-text">{{ item.title }}</span>
                  <span v-if="item.date" class="announcement-date">{{ item.date }}</span>
                </a>
                <div v-else :key="'notice-div-'+idx" class="announcement-item" @click="goToArticle(item)">
                  <span class="announcement-bullet">•</span>
                  <span class="announcement-text">{{ item.title }}</span>
                  <span v-if="item.date" class="announcement-date">{{ item.date }}</span>
                </div>
              </template>
            </div>
          </div>
          <router-link to="/articles?category=3" class="announcement-more-btn">MORE</router-link>
        </div>
      </div>
    </section>
  
    <section class="quick-entry">
      <div class="container">
         <div class="links-header">
          <h3 class="links-title">快速入口</h3>
          <span class="links-subtitle">FRIENDLY LINK</span>
          <div class="links-divider"></div>
        </div>
        <div class="entry-grid">
          <div class="entry-item" v-for="item in quickEntries" :key="item.name" @click="handleEntryClick(item)">
            <div class="entry-image">
              <img :src="item.image" :alt="item.name" />
            </div>
            <div class="entry-title">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="department">
      <div class="container">
        <!-- 暂时隐藏科室介绍标题 -->
        <!-- <h2 class="section-title">科室介绍</h2> -->
        <div class="department-bg">
          <img :src="departmentBg" alt="科室背景"/>
          <div class="department-grid">
            <div class="dept-title-wrapper">
              <div class="dept-title">科室介绍</div>
              <div class="dept-subtitle">DEPARTMENT INTRODUCTION</div>
            </div>
            <div class="dept-rows">
              <div class="dept-row">
                <a v-for="deptName in deptRows[0]" :key="deptName" @click="goToDeptPage(deptName)" class="dept-btn">{{ deptName }}</a>
              </div>
              <div class="dept-row">
                <a v-for="deptName in deptRows[1]" :key="deptName" @click="goToDeptPage(deptName)" class="dept-btn">{{ deptName }}</a>
              </div>
              <div class="dept-row">
                <a v-for="deptName in deptRows[2]" :key="deptName" @click="goToDeptPage(deptName)" class="dept-btn">{{ deptName }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  <section class="news-section">
      <div class="container">
        <!-- 暂时隐藏标签页 -->
        
        <div class="news-tabs">
          <button 
            v-for="(tab, idx) in newsTabs" 
            :key="idx"
            :class="['news-tab', { active: true }]"
            @click="goToNewsTab(tab.path)"
          >
            {{ tab.name }}
          </button>
        </div>
       
        <div class="news-content">
          <div class="news-carousel">
            <button class="carousel-prev" @click="prevNewsImage">‹</button>
            <div class="carousel-image-wrapper" @click="goToCurrentImageArticle()">
              <img :src="newsWithImages[currentImageIndex] && newsWithImages[currentImageIndex].image" alt="新闻图片" />
              <div class="carousel-caption">
                {{ (newsWithImages[currentImageIndex] && newsWithImages[currentImageIndex].title) || '新闻标题' }}
              </div>
            </div>
            <button class="carousel-next" @click="nextNewsImage">›</button>
            <div class="carousel-indicators">
              <span 
                v-for="(item, idx) in newsWithImages" 
                :key="idx"
                :class="['carousel-indicator', { active: currentImageIndex === idx }]"
                @click.prevent="currentImageIndex = idx"
              ></span>
            </div>
          </div>
          <div class="news-list">
            <template v-for="(item, idx) in hospitalNewsList.slice(0, 10)">
              <a v-if="item.external_link" :key="'news-'+idx" :href="item.external_link" target="_blank" class="news-item">
                <span class="news-bullet">•</span>
                <span class="news-title">{{ item.title }}</span>
                <span class="news-date">{{ item.date }}</span>
              </a>
              <div v-else :key="'news2-'+idx" class="news-item" @click="goToArticle(item)">
                <span class="news-bullet">•</span>
                <span class="news-title">{{ item.title }}</span>
                <span class="news-date">{{ item.date }}</span>
              </div>
            </template>
          </div>
        </div>

      </div>
    </section>

    <!-- <section class="doctor-section">
      <div class="container">
        <h2 class="section-title">专家团队</h2>
        <div class="doctor-grid">
          <div class="doctor-card" v-for="doctor in doctors" :key="doctor.id" @click="goToDoctor(doctor.id)">
            <div class="doctor-avatar">
              <img
                :src="doctor.image_url || 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20doctor%20portrait%20medical%20white%20coat&image_size=square'"
                :alt="doctor.name" />
            </div>
            <div class="doctor-name">{{ doctor.name }}</div>
            <div class="doctor-title">{{ doctor.title }}</div>
            <div class="doctor-dept">{{ doctor.department }}</div>
          </div>
        </div>
        <div class="more-btn-wrapper">
          <router-link to="/doctors" class="more-btn">查看更多专家</router-link>
        </div>
      </div>
    </section> -->

    <section class="quick-links">
      <div class="container">
        <div class="links-header">
          <h3 class="links-title">快捷入口</h3>
          <span class="links-subtitle">FRIENDLY LINK</span>
          <div class="links-divider"></div>
        </div>
        <div class="links-grid">
          <div class="links-item" v-for="item in quickLinks" :key="item.name" @click="handleEntryClick(item)">
            <span class="links-item-title">{{ item.name }}</span>
            <span class="links-item-action">点击进入</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import bannerImg1 from '@/assets/images/g1.jpg'
import bannerImg2 from '@/assets/images/g2.jpg'
import bannerImg3 from '@/assets/images/g3.jpg'
import bannerImg4 from '@/assets/images/g4.png'
import bannerImg5 from '@/assets/images/g5.png'
import departmentBgImg from '@/assets/images/ksjsbk.png'
import jyzlImg from '@/assets/images/jyzl.jpg'
import zjjsImg from '@/assets/images/zjjs.jpg'
import ksjsImg from '@/assets/images/ksjs.jpg'
import tszkImg from '@/assets/images/tszk.jpg'

export default {
  name: 'Home',
  data() {
    return {
      activeTab: '医院动态',
      currentBannerIndex: 0,
      bannerImages: [bannerImg1, bannerImg2, bannerImg3, bannerImg4, bannerImg5],
      quickEntries: [
        {
          name: '就医指南',
          image: jyzlImg,
          path: '/medical-guide'
        },
        {
          name: '专家介绍',
          image: zjjsImg,
          path: '/doctors'
        },
        {
          name: '科室介绍',
          image: ksjsImg,
          path: '/departments'
        },
        {
          name: '特色专科',
          image: tszkImg,
          path: '/specialties'
        }
      ],
      departmentBg: departmentBgImg,
      departments: [
        '产科', '新生儿科', '普儿科', '妇科', '妇女保健科',
        '医学遗传科', '美容外科', '口腔科', '眼科', '儿童保健科',
        '中医科', '皮肤科', '眼科', '口腔科', '耳鼻喉科'
      ],
      deptRows: [
        ['产科', '新生儿科', '普儿科', '妇科', '妇女保健科', '医学遗传科', '美容外科'],
        [],
        ['口腔科', '眼科', '儿童保健科', '中医科', '外科', '皮肤科']
      ],
      currentImageIndex: 0,
      currentNewsTab: 0,
      newsTabs: [
        { name: '新闻中心', path: '/news-center' },
        { name: '图片新闻', path: '/image-news' }
      ],
      newsWithImages: [],
      hospitalNewsList: [],
      noticeList: [],
      doctors: [],
      currentNoticeIndex: 0,
      quickLinks: [
        {
          name: '交通指南',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=city%20public%20transportation%20map%20bus%20stop%20sign%20navigation%20direction%20modern%20urban&image_size=square',
          path: '/medical-guide?tab=交通指南'
        },
        {
          name: '下载专区',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=file%20download%20icon%20cloud%20storage%20digital%20document%20modern%20interface&image_size=square',
          path: '/downloads'
        },
        {
          name: '供应商',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=business%20partners%20handshake%20corporate%20office%20professional%20meeting&image_size=square',
          path: 'https://39.129.31.201:5812/',
          external: true
        },
        {
          name: '直报系统',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=data%20reporting%20system%20dashboard%20analytics%20charts%20digital%20medical&image_size=square',
          path: 'https://www.ynfybj.com/index/index/zbxt',
          external: true
        },
         {
          name: '新媒体矩阵',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=data%20reporting%20system%20dashboard%20analytics%20charts%20digital%20medical&image_size=square',
          path: '/xmtjz',
          external: false
        }
      ]
    }
  },
  computed: {
    newsImages() {
      return this.newsWithImages.map(item => item.image)
    },
    displayNotices() {
      const notices = this.noticeList.slice(0, 5)
      if (notices.length === 0) {
        return [{ title: '暂无公告', id: 0 }]
      }
      return notices
    }
  },
  mounted() {
    if (this.isMobileDevice()) {
      window.location.href = 'https://www.ynfybj.com/mobile'
      return
    }
    this.fetchHomeData()
    this.fetchDoctors()
    this.startCarousel()
    this.startBannerCarousel()
    this.startNoticeScroll()
  },
  beforeDestroy() {
    this.stopCarousel()
    this.stopBannerCarousel()
    this.stopNoticeScroll()
  },
  methods: {
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768
    },
    goToCurrentImageArticle() {
      const item = this.newsWithImages[this.currentImageIndex]
      if (item && item.id) {
        if (item.external_link) {
          window.open(item.external_link, '_blank')
        } else {
          this.goToArticle(item.id)
        }
      }
    },
    prevNewsImage() {
      this.currentImageIndex = (this.currentImageIndex - 1 + this.newsWithImages.length) % this.newsWithImages.length
    },
    nextNewsImage() {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.newsWithImages.length
    },
    goToNewsList() {
      this.$router.push('/news-center')
    },
    goToNewsTab(path) {
      this.$router.push(path)
    },
    startCarousel() {
      this.carouselTimer = setInterval(() => {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.newsWithImages.length
      }, 3000)
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
      }
    },
    startBannerCarousel() {
      this.bannerTimer = setInterval(() => {
        this.currentBannerIndex = (this.currentBannerIndex + 1) % this.bannerImages.length
      }, 4000)
    },
    stopBannerCarousel() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer)
      }
    },
    async fetchHomeData() {
      try {
        const response = await axios.get('/api/home')
        console.log('=== 首页API完整响应 ===', response.data)
        const data = response.data.data
        console.log('=== data.hospital_news ===', data.hospital_news)
        console.log('=== data.announcement_news ===', data.announcement_news)
        this.hospitalNewsList = data.hospital_news
        console.log('=== hospitalNewsList直接赋值 ===', this.hospitalNewsList)
        this.noticeList = data.announcement_news
        console.log('=== noticeList直接赋值 ===', this.noticeList)
        
        // 获取"图片新闻"栏目的文章
        const imageNewsResponse = await axios.get('/api/image-news')
        if (imageNewsResponse.data.success && imageNewsResponse.data.data) {
          this.newsWithImages = imageNewsResponse.data.data
          console.log('=== 图片新闻数据 ===', this.newsWithImages)
        }
      } catch (error) {
        console.error('获取首页数据失败:', error)
      }
    },
    async fetchDoctors() {
      try {
        const response = await axios.get('/api/doctors', {
          params: {
            page: 1,
            size: 6
          }
        })
        console.log('医生API原始响应:', response)
        const rawData = (response.data && response.data.success && Array.isArray(response.data.data))
          ? response.data.data
          : []
        this.doctors = rawData.map(doc => ({
          id: doc.id || 0,
          name: doc.name || '',
          title: '',
          department: '',
          image_url: doc.image_url || ''
        }))
        console.log('处理后的医生数据:', this.doctors)
      } catch (error) {
        console.error('获取医生数据失败:', error)
      }
    },
    loadMockData() {
      this.activities['医院动态'].list = [
        { id: 1, title: '医院举办2024年第一期中层干部培训', date: '2024-01-15' },
        { id: 2, title: '我院开展春节前安全生产大检查', date: '2024-01-10' },
        { id: 3, title: '云南省妇幼保健院召开2023年度工作总结会', date: '2024-01-05' },
        { id: 4, title: '我院成功举办省级继续医学教育项目', date: '2023-12-28' },
        { id: 5, title: '关爱女性健康公益活动走进社区', date: '2023-12-20' },
        { id: 6, title: '我院儿科团队荣获省级表彰', date: '2023-12-15' },
        { id: 7, title: '新院区二期工程进展顺利', date: '2023-12-10' },
        { id: 8, title: '医院开展世界艾滋病日宣传活动', date: '2023-12-01' }
      ]
    },
    loadMockDoctors() {
      this.doctors = [
        { id: 1, name: '张医生', title: '主任医师', department: '妇科', image_url: '' },
        { id: 2, name: '李医生', title: '副主任医师', department: '产科', image_url: '' },
        { id: 3, name: '王医生', title: '主任医师', department: '儿科', image_url: '' },
        { id: 4, name: '陈医生', title: '副主任医师', department: '新生儿科', image_url: '' },
        { id: 5, name: '刘医生', title: '主任医师', department: '乳腺科', image_url: '' },
        { id: 6, name: '赵医生', title: '副主任医师', department: '生殖医学科', image_url: '' }
      ]
    },
    handleEntryClick(item) {
      if (item.path) {
        if (item.external) {
          window.open(item.path, '_blank')
        } else {
          this.$router.push(item.path)
        }
      }
    },
    goToArticle(article) {
      if (typeof article === 'object' && article.external_link) {
        window.open(article.external_link, '_blank')
      } else {
        const id = typeof article === 'object' ? article.id : article
        this.$router.push(`/article/${id}`)
      }
    },
    goToDoctor(id) {
      this.$router.push(`/doctor/${id}`)
    },
    goToDeptPage(deptName) {
      this.$router.push({ path: '/departments', query: { dept: deptName } })
    },
    startNoticeScroll() {
      this.noticeScrollTimer = setInterval(() => {
        const notices = this.displayNotices
        if (notices.length > 1) {
          this.currentNoticeIndex = (this.currentNoticeIndex + 1) % notices.length
          this.updateScrollPosition()
        }
      }, 4000)
    },
    stopNoticeScroll() {
      if (this.noticeScrollTimer) {
        clearInterval(this.noticeScrollTimer)
        this.noticeScrollTimer = null
      }
    },
    updateScrollPosition() {
      const wrapper = document.querySelector('.announcement-scroll-wrapper')
      if (wrapper) {
        wrapper.style.transform = `translateY(-${this.currentNoticeIndex * 40}px)`
      }
    },
    pauseScroll() {
      this.stopNoticeScroll()
    },
    resumeScroll() {
      this.startNoticeScroll()
    }
  }
}
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100vh;
  background: #fff;
}

.banner {
  width: 100%;
  overflow: hidden;

  .banner-container {
    width: 100%;
    height: 0;
    padding-bottom: 28%; /* 700/2500 = 0.28 */
    position: relative;
    overflow: hidden;

    .banner-slide {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.8s ease;
      z-index: 1;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      &.active {
        opacity: 1;
        z-index: 2;
      }
    }

    .banner-dots {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 15px;
      z-index: 10;

      .banner-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        transition: all 0.3s;

        &.active {
          background: #4ecdc4;
          transform: scale(1.3);
        }
      }
    }
  }
}

.announcement-section {
  padding: 25px 0 15px;
  background: white;
  // border-top: 1px solid #eee;
  // border-bottom: 1px solid #eee;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .announcement-card {
    display: flex;
    align-items: center;
    height: 40px;
    background: white;
    border: 1px solid #86cbc0;
    border-radius: 4px;
    overflow: hidden;

    .announcement-tag {
      display: flex;
      align-items: center;
      background: linear-gradient(135deg, #86cbc0 0%, #00aeaa 100%);
      padding: 0 15px;
      height: 100%;
      color: white;
      font-weight: bold;
      font-size: 14px;

      .announcement-icon {
        margin-right: 6px;
        font-size: 16px;
      }

      .announcement-label {
        letter-spacing: 2px;
      }
    }

    .announcement-scroll-container {
      flex: 1;
      height: 100%;
      overflow: hidden;
      position: relative;

      .announcement-scroll-wrapper {
        transition: transform 0.5s ease-in-out;

        .announcement-item {
          display: flex;
          align-items: center;
          height: 40px;
          padding: 0 10px;
          cursor: pointer;
          transition: color 0.2s;
          text-decoration: none;

          &:hover {
            color: #4ecdc4;
          }

          .announcement-bullet {
            color: #4ecdc4;
            margin-right: 8px;
            font-size: 12px;
          }

          .announcement-text {
            color: #333;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .announcement-date {
            color: #999;
            font-size: 12px;
            margin-left: 15px;
            white-space: nowrap;
          }
        }
      }
    }

    .announcement-more-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #86cbc0 0%, #00aeaa 100%);
      padding: 0 20px;
      height: 100%;
      color: white;
      font-weight: bold;
      font-size: 14px;
      text-decoration: none;
      transition: background 0.3s;

      &:hover {
        background: linear-gradient(135deg, #00aeaa 0%, #00aeaa 100%);
      }
    }
  }
}

.quick-entry {
  padding: 40px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .links-header {
    text-align: center;
    margin-bottom: 30px;

    .links-title {
      font-size: 24px;
      color: #333;
      font-weight: bold;
      margin: 0;
    }

    .links-subtitle {
      display: block;
      font-size: 12px;
      color: #999;
      margin-top: 5px;
      letter-spacing: 2px;
    }

    .links-divider {
      width: 60px;
      height: 2px;
      background: #4ecdc4;
      margin: 10px auto 0;
    }
  }

  .section-title {
    font-size: 24px;
    color: #333;
    text-align: center;
    margin-bottom: 30px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: #4ecdc4;
    }
  }

  .entry-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .entry-item {
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s, box-shadow 0.3s;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .entry-image {
        width: 100%;
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .entry-title {
        text-align: center;
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        padding: 12px 0;
        background: linear-gradient(135deg, #86cbc0 0%, #00aeaa 50%,  #86cbc0 100%);
        margin: 0;
      }
    }
  }
}

.department {
  padding: 50px 0;
  background: #f8f9fa;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section-title {
    font-size: 28px;
    color: #333;
    text-align: center;
    margin-bottom: 35px;
    position: relative;
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 70px;
      height: 4px;
      background: #4ecdc4;
      border-radius: 2px;
    }
  }

  .department-bg {
    position: relative;
    border-radius: 18px;
    overflow: hidden;
    height: 350px;

    img {
      width: 100%;      
      object-fit: cover;
      transform: translateY(-180px);
    }

    .department-grid {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 50px 60px;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;

      .dept-title-wrapper {
        text-align: center;
        margin-bottom: 50px;

        .dept-title {
          font-size: 24px;
          color: #fff;
          font-weight: bold;
          margin-bottom: 8px;
        }

        .dept-subtitle {
          font-size: 14px;
          color: #fff;
          font-style: italic;
          letter-spacing: 4px;
          position: relative;

          &::before,
          &::after {
            content: '—';
            margin: 0 10px;
          }
        }
      }

      .dept-rows {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 100%;
        max-width: 1000px;

        .dept-row {
          display: flex;
          justify-content: center;
          gap: 15px;
          flex-wrap: wrap;

          .dept-btn {
            background: rgba(230, 180, 170, 0.9);
            border: none;
            padding: 12px 30px;
            border-radius: 6px;
            font-size: 15px;
            color: #fff;
            cursor: pointer;
            transition: all 0.3s;
            text-decoration: none;
            font-weight: 500;
            text-align: center;
            white-space: nowrap;

            &:hover {
              background: rgba(210, 150, 140, 0.95);
              transform: translateY(-2px);
            }
          }
        }
      }
    }
  }
}

.news-section {
  padding: 40px 0;
  background: white;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .news-tabs {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;

    .news-tab {
      padding: 10px 30px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &.active {
        background: #00aeaa;
        color: white;
        border-color: #00aeaa;
      }

      &:hover:not(.active) {
        background: #f8f9fa;
      }
    }
  }

  .news-content {
    display: flex;
    gap: 20px;

    .news-carousel {
      width: 50%;
      position: relative;
      height: 300px;
      overflow: hidden;

      .carousel-prev,
      .carousel-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        border: none;
        font-size: 24px;
        cursor: pointer;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.7);
        }
      }

      .carousel-prev {
        left: 10px;
      }

      .carousel-next {
        right: 10px;
      }

      .carousel-image-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .carousel-caption {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          font-size: 14px;
          padding: 12px 15px;
        }
      }

      .carousel-indicators {
        position: absolute;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 8px;

        .carousel-indicator {
          width: 10px;
          height: 10px;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 50%;
          cursor: pointer;
          transition: background 0.3s;

          &.active {
            background: white;
          }
        }
      }
    }

    .news-list {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .news-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        cursor: pointer;
        text-decoration: none;
        transition: background 0.2s;
        padding: 6px 10px;
        border-radius: 4px;

        &:hover {
          background: #f8f9fa;
        }

        .news-bullet {
          color: #4ecdc4;
          margin-right: 10px;
          font-size: 12px;
          flex-shrink: 0;
        }

        .news-title {
          flex: 1;
          font-size: 14px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.5;
          margin-right: 10px;
        }

        .news-date {
          font-size: 12px;
          color: #999;
          flex-shrink: 0;
        }
      }
    }
  }

  .news-more-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .news-more-btn {
      padding: 10px 60px;
      border: 1px solid #ddd;
      background: white;
      color: #666;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #f8f9fa;
        border-color: #ccc;
      }
    }
  }
}

.doctor-section {
  padding: 40px 0;
  background: #f8f9fa;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section-title {
    font-size: 24px;
    color: #333;
    text-align: center;
    margin-bottom: 30px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: #4ecdc4;
    }
  }

  .doctor-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
    margin-bottom: 30px;

    .doctor-card {
      background: white;
      border-radius: 10px;
      padding: 20px;
      text-align: center;
      cursor: pointer;
      transition: transform 0.3s;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-5px);
      }

      .doctor-avatar {
        width: 80px;
        height: 80px;
        margin: 0 auto 15px;
        border-radius: 50%;
        overflow: hidden;
        background: #f0f0f0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .doctor-name {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        margin-bottom: 5px;
      }

      .doctor-title {
        font-size: 12px;
        color: #4ecdc4;
        margin-bottom: 5px;
      }

      .doctor-dept {
        font-size: 11px;
        color: #999;
      }
    }
  }

  .more-btn-wrapper {
    text-align: center;

    .more-btn {
      background: #4ecdc4;
      color: white;
      border: none;
      padding: 12px 40px;
      border-radius: 25px;
      font-size: 16px;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        background: #44a08d;
      }
    }
  }
}

.quick-links {
  padding: 40px 0;
  background: #f8f9fa;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .links-header {
    text-align: center;
    margin-bottom: 30px;

    .links-title {
      font-size: 24px;
      color: #333;
      font-weight: bold;
      margin: 0;
    }

    .links-subtitle {
      display: block;
      font-size: 12px;
      color: #999;
      margin-top: 5px;
      letter-spacing: 2px;
    }

    .links-divider {
      width: 60px;
      height: 2px;
      background: #4ecdc4;
      margin: 10px auto 0;
    }
  }

  .links-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;

    .links-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 15px;
      background: white;
      border: 1px solid #eee;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #4ecdc4;
        background: #f0fdfa;
      }

      .links-item-title {
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .links-item-action {
        font-size: 12px;
        color: #999;
      }
    }
  }
}
</style>
